import React from "react";

import images from "../../../utils/images";

import "./styles.scss";

/**
 * This is the progress bar component
 * four props can be passed now, height, pri, sec
 * prop 'now' is mandatory
 *
 */

const ProgressBar = (props) => {
  let { currentMarker, currentMarkerTitle, height, now } = props;

  let classes = "ProgressBar";

  if (props.className) {
    classes = classes + " " + props.className;
  }

  let styles_inner = {
    height,
    transform: `translate3d(${now + "%"},0,0)`,
  };
  let styles_outer = {
    height,
  };

  const currentMarkerStyle = {
    fontSize: 12,
    marginBottom: -10,
    marginLeft: `calc(${now}% - ${currentMarker > 9 ? "26" : "22"}px)`,
    maxWidth: 75,
  };

  return (
    <div>
      {currentMarker && currentMarkerTitle && (
        <div>
          <div style={currentMarkerStyle}>
            <b>{currentMarkerTitle}</b>
          </div>
          <img
            alt=""
            src={images("./common/green-chevron.svg")}
            style={{ marginBottom: -5, marginLeft: `calc(${now}% - 8px)` }}
          />
        </div>
      )}
      <div className={classes} style={styles_outer}>
        <div className="ProgressBar__progress" style={styles_inner} />
      </div>
    </div>
  );
};

export default ProgressBar;
